import { Row, Col, Form, Input, Button, Modal, message, Space, Card, Upload, Switch, TreeSelect } from 'antd';
import React, { Children, useEffect, useRef, useState } from 'react';
import AdminModal from './AdminModal';
import { useContext } from 'react';
import axios from 'axios';
import { CloseOutlined, InboxOutlined } from '@ant-design/icons';
import UploadImg from '../UploadImg';
import JoditEditor from 'jodit-react';
import { useRoom } from '../../audio_recorder/controller/RoomController';
import News from '../../news/views/News';
import NewsOnlyRead from '../../news/views/NewsOnlyRead'
const BlogForm = (
    {
        propsForm = null,
        axiosMode = "post",
        propsValue = null,
        total,
        open = false,
        onSuccess = () => {

        },
        onError = () => {

        },
        frontendComponentId = null,
        propertyJsonShow = null
    }
) => {
    const [form] = Form.useForm();
    const [checkStrictly, setCheckStrictly] = useState(0);
    const [internalLink, setInternalLink] = useState([]);
    const [blogFieldId, setBlogFieldId] = useState();
    const youtubeDetectRef = useRef(setTimeout(() => { }, 0));
    // const configContext = useContext(ConfigContext)
    // const value = useSettingValue({ inputValue: propsValue, isModalOpen: open })
    const onFinish = (values) => {
        let resultData = []
        resultData = values?.items.map((mapItem, mapIndex) => {
            let blogData = []
            blogData = mapItem.frontend_column_frontend_component_blog_type_blog_data.map((dataItem, dataIndex) => {
                let extermal_link_check = 0
                if (dataItem.extermal_link_check === true) {
                    extermal_link_check = 1
                }
                else if (dataItem.extermal_link_check === false) {
                    extermal_link_check = 0

                }
                return ({
                    ...dataItem,
                    extermal_link_check: extermal_link_check
                })
            })
            return (
                {
                    ...mapItem,
                    frontend_column_frontend_component_blog_type_blog_data: blogData
                }
            )
        })
        onSuccess(resultData)
        // console.log(resultData)

    }
    const onValuesChange = () => {
        let values = {};
        if (!!propsForm) {
            values = propsForm.getFieldsValue()
        }
        else {
            values = form.getFieldsValue()
        }
        let resultData = []
        resultData = values
        clearTimeout(youtubeDetectRef.current);
        youtubeDetectRef.current = setTimeout(onYoutubeDetect, 1000);
        if (!!propsForm) {
            propsForm.setFieldsValue({
                items: resultData
            })
        }
        else {
            form.setFieldsValue({
                items: resultData
            })
        }
    }
    const onYoutubeDetect = () => {
        let values = {};
        if (!!propsForm) {
            values = propsForm.getFieldsValue()
        }
        else {
            values = form.getFieldsValue()
        }
        let resultData = []
        resultData = values?.items.map((mapItem, mapIndex) => {
            let blogData = []
            blogData = mapItem.frontend_column_frontend_component_blog_type_blog_data.map((dataItem, dataIndex) => {
                let element = '';
                if (dataItem.youtube_iframe !== '') {
                    let stringhtml = dataItem.youtube_iframe
                    let parser = new DOMParser();
                    let parsedResult = parser.parseFromString(stringhtml, 'text/html');
                    element = parsedResult.getElementsByTagName('iframe')
                    for (let index = 0; index < element.length; index++) {
                        const item = element[index];

                        item.setAttribute('width', '100%');
                        item.setAttribute('height', '100%');

                    }
                }
                return ({
                    ...dataItem,
                    youtube_iframe: element[0]?.outerHTML
                })
            })
            return (
                {
                    ...mapItem,
                    frontend_column_frontend_component_blog_type_blog_data: blogData
                }
            )
        })
        if (!!propsForm) {
            propsForm.setFieldsValue({
                items: resultData
            })
        }
        else {
            form.setFieldsValue({
                items: resultData
            })
        }

    }
    const onImagesChange = (fieldName, subFieldName, name, changeValue, checkStrictly) => {
        let { items } = propsForm.getFieldsValue()
        if (items[fieldName]) {
            if (items[fieldName].frontend_column_frontend_component_blog_type_blog_data[subFieldName]) {
                items[fieldName].frontend_column_frontend_component_blog_type_blog_data[subFieldName].blog_type_classify_structure_type_blog_data = changeValue
            }
            else {
                let frontend_column_frontend_component_blog_type_blog_data_temp = {
                    "blog_type_blog_id": null,
                    "blog_id": null,
                    "title": null,
                    "content": null,
                    "annoucement_time": "2023-09-28T18:50:27.967904+08:00",
                    "top": null,
                    "top_edit_time": null,
                    "blog_index": null,
                    "more_content": null,
                    "show": null,
                    "external_link": null,
                    "youtube_iframe": null,
                    "youtube_thumbnail": null,
                    "property_json": null,
                    "extermal_link_check": null,
                    "blog_type_classify_structure_type_blog_data": changeValue
                }
                console.log({
                    frontend_column_frontend_component_blog_type_blog_data_temp
                })
                items[fieldName].frontend_column_frontend_component_blog_type_blog_data[subFieldName] = frontend_column_frontend_component_blog_type_blog_data_temp
            }
        }
        console.log({
            items
        })
        setCheckStrictly(pre => pre + 1)
        propsForm.setFieldsValue({ items: items })
    }
    const getExtermalLinkCheck = (field_name, subField_name) => {
        let temp = []
        if (propsForm) {
            temp = propsForm.getFieldValue(['items', field_name, 'frontend_column_frontend_component_blog_type_blog_data', subField_name, 'extermal_link_check'])
        }
        else {
            temp = form.getFieldValue(['items', field_name, 'frontend_column_frontend_component_blog_type_blog_data', subField_name, 'extermal_link_check'])
        }
        return temp
    }
    const getFileListValue = (field_name, subField_name) => {
        let temp = []
        if (propsForm) {
            temp = propsForm.getFieldValue(['items', field_name, 'frontend_column_frontend_component_blog_type_blog_data', subField_name, 'blog_type_classify_structure_type_blog_data'])
        }
        else {
            temp = form.getFieldValue(['items', field_name, 'frontend_column_frontend_component_blog_type_blog_data', subField_name, 'blog_type_classify_structure_type_blog_data'])
        }

        return temp
    }
    const getBlogNewsData = (field_name, subField_name) => {
        let temp = []
        if (propsForm) {
            temp = propsForm.getFieldValue(['items', field_name, 'frontend_column_frontend_component_blog_type_blog_data', subField_name, 'blog_news_data'])
        }
        else {
            temp = form.getFieldValue(['items', field_name, 'frontend_column_frontend_component_blog_type_blog_data', subField_name, 'blog_news_data'])
        }
        temp = (temp || []).map((value) => {
            return value?.news_id
        })
        return temp
    }
    useEffect(() => {
        if (!!propsForm) {
            propsForm.setFieldsValue({ items: propsValue })
        }
        else {
            form.setFieldsValue({ items: propsValue })
        }
    }, [propsValue])


    useEffect(() => {
        axios.get('/dynamicWebsite/frontend/permission', {
            params: {
                classify_structure_id: 5,
                classify_structure_type_id: 0,

            }
        })
            .then(response => {
                setInternalLink(response?.data['data'].map(map_item => ({
                    title: map_item.name,
                    value: `/officialweb/frontend/` + map_item.name,
                    children: map_item.children.map(map_item => ({
                        title: map_item.name,
                        value: `/officialweb/frontend/` + map_item.name,
                        children: map_item.children
                    }))
                })))
                // setMenuItem(response?.data['data'])
            })
            .catch((error) => {
            })
            .finally(() => {
            })
    }, [])
    const fieldIdOnClick = (blogFieldId) => {
        setBlogFieldId(blogFieldId)
    }

    return (
        <Row>
            <Col span={24}>
                <Form
                    // labelCol={{
                    //     span: 4,
                    // }}
                    // wrapperCol={{
                    //     span: 24,
                    // }}
                    layout="vertical"

                    form={
                        !!propsForm ? propsForm : form
                    }
                    name="dynamic_form_complex"
                    autoComplete="off"
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.List name="items">
                                {(fields, { add, remove }) => (
                                    <Row gutter={[8, 8]} justify={'center'}>
                                        <Col span={24}>
                                            <Button type="dashed" onClick={() => add()} block>
                                                + 新增分類
                                            </Button>
                                        </Col>
                                        {fields.map((field) => (
                                            <Col span={24}>
                                                <Row gutter={[8, 8]} justify={'space-between'}>
                                                    <Col
                                                        lg={8}
                                                        md={24}
                                                        sm={24}
                                                        xs={24}>
                                                        <Row gutter={[8, 8]} justify={'space-between'}>
                                                            <Col span={24}>
                                                                <Card
                                                                    size="small"
                                                                    title={`分類 ${field.name + 1}`}
                                                                    key={field.key}
                                                                    extra={
                                                                        <CloseOutlined
                                                                            onClick={() => {
                                                                                remove(field.name);
                                                                            }}
                                                                        />
                                                                    }
                                                                >
                                                                    <Form.Item label="貼文分類" name={[field.name, 'blog_type_name']}>
                                                                        <Input />
                                                                    </Form.Item>
                                                                    <Col span={24}>
                                                                        <Form.Item label="貼文">
                                                                            <Form.List name={[field.name, 'frontend_column_frontend_component_blog_type_blog_data']}>
                                                                                {(subFields, subOpt) => (
                                                                                    // <div style={{ display: 'flex', flexDirection: 'column', rowGap: 16 }}>
                                                                                    <Row gutter={[8, 8]} justify={'space-between'}>
                                                                                        <Col span={24}>
                                                                                            <Card>
                                                                                                {subFields.map((subField) => (
                                                                                                    <Card.Grid
                                                                                                        key={subField.key}
                                                                                                        onClick={() => fieldIdOnClick(subField.name)}
                                                                                                    // extra={
                                                                                                    //     <CloseOutlined
                                                                                                    //         onClick={() => {
                                                                                                    //             subOpt.remove(subField.name);
                                                                                                    //         }}
                                                                                                    //     />
                                                                                                    // }
                                                                                                    >
                                                                                                        {(propsForm ? propsForm : form).getFieldValue(['items', field.name, 'frontend_column_frontend_component_blog_type_blog_data', subField.name, 'title'])}
                                                                                                        {/* { console.log((propsForm ? propsForm : form).getFieldValue(['items', field.name, 'frontend_column_frontend_component_blog_type_blog_data', subField.name, 'title']))} */}
                                                                                                    </Card.Grid>
                                                                                                ))}
                                                                                            </Card>
                                                                                        </Col>
                                                                                        <Col span={24}>
                                                                                            <Button type="dashed" onClick={() => subOpt.add()} block>
                                                                                                + 新增貼文
                                                                                            </Button>
                                                                                        </Col>

                                                                                    </Row>

                                                                                    // </div>
                                                                                )}
                                                                            </Form.List>
                                                                        </Form.Item>
                                                                    </Col>
                                                                </Card>
                                                            </Col>

                                                        </Row>
                                                    </Col>

                                                    {/* <Card> */}

                                                    <Col
                                                        lg={16}
                                                        md={24}
                                                        sm={24}
                                                        xs={24}>

                                                        {/* Nest Form.List */}
                                                        <Form.Item>
                                                            <Form.List name={[field.name, 'frontend_column_frontend_component_blog_type_blog_data']}>
                                                                {(subFields, subOpt) => (
                                                                    // <div style={{ display: 'flex', flexDirection: 'column', rowGap: 16 }}>
                                                                    <>
                                                                        {subFields.map((subField) => (
                                                                            <Card
                                                                                size="small"
                                                                                title={`貼文 ${subField.name + 1}`}
                                                                                key={field.key}
                                                                                extra={
                                                                                    <CloseOutlined
                                                                                        onClick={() => {
                                                                                            subOpt.remove(subField.name);
                                                                                        }}
                                                                                    />
                                                                                }
                                                                                hidden={blogFieldId !== subField.name}
                                                                            >

                                                                                <Form.Item
                                                                                    label="文章標題"
                                                                                    name={[subField.name, 'title']}
                                                                                    
                                                                                    hidden={!propertyJsonShow ? false : !propertyJsonShow["title"]}
                                                                                >
                                                                                    <Input />
                                                                                </Form.Item>
                                                                                <Form.Item
                                                                                    label="貼文內容" name={[subField.name, 'content']}
                                                                                   
                                                                                    hidden={!propertyJsonShow ? false : !propertyJsonShow["content"]}

                                                                                >
                                                                                    <Input.TextArea />
                                                                                </Form.Item>
                                                                                <Form.Item
                                                                                    label={"連結設定"}
                                                                                    name={[subField.name, 'extermal_link_check']}

                                                                                    valuePropName="checked"
                                                                                    hidden={!propertyJsonShow ? false : !propertyJsonShow["extermal_link_check"]}

                                                                                >
                                                                                    <Switch
                                                                                        checkedChildren="外部連結"
                                                                                        unCheckedChildren="內部連結"
                                                                                        onChange={() => {
                                                                                            setCheckStrictly(pre => pre + 1)
                                                                                        }}
                                                                                    />

                                                                                </Form.Item>

                                                                                <Form.Item
                                                                                    label={getExtermalLinkCheck(field.name, subField.name) ? "外部連結" : "內部連結"}
                                                                                    name={[subField.name, 'external_link']}
                                                                                    hidden={!propertyJsonShow ? false :!propertyJsonShow["external_link"]}

                                                                                // rules={[
                                                                                //     {
                                                                                //         required: true,
                                                                                //         message: `此為必填項目`
                                                                                //     },
                                                                                // ]}
                                                                                >{
                                                                                        getExtermalLinkCheck(field.name, subField.name) ?
                                                                                            <Input />
                                                                                            :
                                                                                            <TreeSelect
                                                                                                treeData={internalLink}
                                                                                                // defaultValue={departmentId}
                                                                                                showSearch
                                                                                                style={{
                                                                                                    width: '100%',
                                                                                                }}
                                                                                                // value={internalLink}
                                                                                                dropdownStyle={{
                                                                                                    maxHeight: 400,
                                                                                                    overflow: 'auto',
                                                                                                }}
                                                                                                placeholder="選擇頁面"
                                                                                                allowClear
                                                                                                treeDefaultExpandAll
                                                                                                treeNodeFilterProp={"title"}
                                                                                                onChange={
                                                                                                    (e) => {
                                                                                                        // setDepartmentId(e)
                                                                                                    }
                                                                                                }
                                                                                                multiple={false}
                                                                                            // treeData={departmentData}
                                                                                            />
                                                                                    }
                                                                                </Form.Item>
                                                                                <Form.Item label="上傳圖片"
                                                                                    hidden={!propertyJsonShow ? false :!propertyJsonShow["blog_type_classify_structure_type_blog_data"]}
                                                                                >
                                                                                    <Form.Item
                                                                                        name={[subField.name, 'blog_type_classify_structure_type_blog_data']}
                                                                                        valuePropName="fileList"
                                                                                        noStyle
                                                                                        initialValue={[]}
                                                                                        hidden={!propertyJsonShow ? false :!propertyJsonShow["blog_type_classify_structure_type_blog_data"]}

                                                                                    >
                                                                                        <UploadImg
                                                                                            // api=''
                                                                                            defaultValue={getFileListValue(field.name, subField.name, checkStrictly)}
                                                                                            onImagesChange={(value) => {
                                                                                                onImagesChange(field.name, subField.name, 'blog_type_classify_structure_type_blog_data', value, checkStrictly)
                                                                                            }}
                                                                                        />
                                                                                    </Form.Item>
                                                                                </Form.Item>
                                                                                <Form.Item
                                                                                    label={"Youtube連結"}
                                                                                    name={[subField.name, 'youtube_iframe']}

                                                                                    hidden={!propertyJsonShow ? false :!propertyJsonShow["youtube_iframe"]}

                                                                                >
                                                                                    <Input.TextArea>
                                                                                    </Input.TextArea>
                                                                                </Form.Item>
                                                                                <Form.Item
                                                                                    name={[subField.name, 'blog_news_data']}
                                                                                    hidden={!propertyJsonShow ? false :!propertyJsonShow["blog_news_data"]}

                                                                                >
                                                                                    <News
                                                                                        defaultSize={10}
                                                                                        showSwitch={true}
                                                                                        propsShowColumns={["news_title", 'staff_name','news_type_name', 'news_time', 'announce_time_end', 'news_id', 'option']}
                                                                                        propsCheckSelectRowKeys={getBlogNewsData(field.name, subField.name, checkStrictly)}
                                                                                        // propsCheckSelectedRowsInfo={[]}
                                                                                        propsMode={false}
                                                                                        showNewsType={true}
                                                                                        onCheckSelectChange={(keys, infos) => {
                                                                                            let newsIdData = keys.map((val, index) => {
                                                                                                return {
                                                                                                    news_id: val
                                                                                                }
                                                                                            })

                                                                                            if (propsForm) {
                                                                                                propsForm.setFieldValue(['items', field.name, 'frontend_column_frontend_component_blog_type_blog_data', subField.name, 'blog_news_data'], [...newsIdData])
                                                                                            }
                                                                                            else {
                                                                                                form.setFieldValue(['items', field.name, 'frontend_column_frontend_component_blog_type_blog_data', subField.name, 'blog_news_data'], [...newsIdData])
                                                                                            }

                                                                                        }}
                                                                                    />
                                                                                </Form.Item>
                                                                                <Form.Item
                                                                                    label={"直播字幕"}
                                                                                    hidden={!propertyJsonShow ? false :!propertyJsonShow["blog_room_data"]}

                                                                                >
                                                                                    <Switch
                                                                                        checkedChildren="開啟" unCheckedChildren="關閉" defaultChecked={((propsForm ? propsForm : form).getFieldValue(['items', field.name, 'frontend_column_frontend_component_blog_type_blog_data', subField.name, 'blog_room_data']) ?? []).length !== 0}
                                                                                        onChange={(e) => {
                                                                                            if (e)
                                                                                                (propsForm ? propsForm : form).setFieldValue(['items', field.name, 'frontend_column_frontend_component_blog_type_blog_data', subField.name, 'blog_room_data'], [{}])
                                                                                            else
                                                                                                (propsForm ? propsForm : form).setFieldValue(['items', field.name, 'frontend_column_frontend_component_blog_type_blog_data', subField.name, 'blog_room_data'], [])
                                                                                        }}
                                                                                    />
                                                                                </Form.Item>
                                                                                <Form.List name={[field.name, 'blog_room_data']}>
                                                                                    {(subRoomFields, subRoomOpt) => (
                                                                                        // <div style={{ display: 'flex', flexDirection: 'column', rowGap: 16 }}>
                                                                                        <>
                                                                                            {subRoomFields.map((subRoomField) => (<>
                                                                                                <Form.Item
                                                                                                    hidden
                                                                                                    name={[subRoomField.name, 'blog_room_id']}
                                                                                                >
                                                                                                </Form.Item>
                                                                                                <Form.Item
                                                                                                    hidden
                                                                                                    name={[subRoomField.name, 'room_id']}
                                                                                                >
                                                                                                </Form.Item>
                                                                                            </>))}
                                                                                        </>
                                                                                    )}
                                                                                </Form.List>
                                                                                <Form.Item
                                                                                    label={"詳細內容"}
                                                                                    name={[subField.name, 'more_content']}

                                                                                    hidden={true}

                                                                                >
                                                                                    <Input.TextArea>
                                                                                    </Input.TextArea>
                                                                                </Form.Item>
                                                                                <Form.Item
                                                                                    label={"詳細內容"}
                                                                                    hidden={!propertyJsonShow ? false :!propertyJsonShow["more_content"]}

                                                                                >
                                                                                    <Editor
                                                                                        propsForm={!!propsForm ? propsForm : form}
                                                                                        propsValue={propsValue}
                                                                                        field_name={field.name}
                                                                                        subField_name={subField.name}
                                                                                        field={['items', field.name, 'frontend_column_frontend_component_blog_type_blog_data', subField.name, 'more_content']}
                                                                                    />
                                                                                </Form.Item>
                                                                            </Card>

                                                                        ))}
                                                                    </>
                                                                    // </div>
                                                                )}
                                                            </Form.List>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </Col >
                                        ))}

                                    </Row>
                                )}
                            </Form.List>
                        </Col>

                    </Row>
                </Form>
            </Col>
        </Row >
    )
}
export default BlogForm;
const Editor = ({
    propsForm = null,
    propsValue = null,
    field_name = null,
    subField_name = null,
    field = []
}) => {
    const [form] = Form.useForm();
    const [content, setContent] = useState("")
    const editor = useRef(null);
    const config = {
        // readonly: false, // all options from https://xdsoft.net/jodit/doc/
        // uploader: {
        //     insertImageAsBase64URI: true,
        //     // url: `${axios.defaults.baseURL}/api/literacy/admin/editor/file`
        // },
        // language: 'zh_tw'
        allowResizeTags: false,
        imageDefaultWidth: "100%",
        language: 'zh_tw',
        i18n: {
            zh_tw: {
                'Default': "預設",
                'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
                    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.',
                Anchor: 'Anchor',
                Margins: '外邊距（Margins）',
                top: 'top',
                right: 'right',
                bottom: 'bottom',
                left: 'left',
                Classes: 'Classes',
                Src: 'Src',
                Title: 'Title',
                Link: 'Link',
                file: 'file',
                'Image properties': '圖片屬性',
                'Your code is similar to HTML. Keep as HTML?':
                    '你黏貼的文本是一段html代碼，是否保留源格式',
                'Paste as HTML': 'html黏貼',
                'Insert as Text': '把html代碼視為普通文本',
                'Error on load list': '加載list錯誤',
                Break: 'Pause',
                'No follow': 'No follow',
                'URL': 'URL',
                Crop: 'Crop',
                Default: '默認',
                Circle: '圓圈',
                Dot: '點',
                Quadrate: '方形',
                Find: '搜尋',
                'Insert className': '插入標籤名稱',
                'Press Alt for custom resizing': '按Alt自定義調整大小',
                'Find Next': '找下一個',
                'Find Previous': '找上一個',
                'replace': '替代',
                'Line height': '行高'
            }
        },
        uploader: {
            insertImageAsBase64URI: true,
            imagesExtensions: [
                "jpg",
                "png",
                "jpeg",
                "gif",
                "svg",
                "webp",
            ],
        },
    };

    const onContentChange = (content, field) => {
        setContent(content)
        if (propsForm) {
            propsForm.setFieldValue(field, content)
        }
        else {
            form.setFieldValue(field, content)
        }
    }

    useEffect(() => {
        setContent(propsValue?.[field_name]?.['frontend_column_frontend_component_blog_type_blog_data']?.[subField_name]?.['more_content'])
    }, [propsValue])
    return (<>
        <JoditEditor
            ref={editor}
            value={content}
            config={config}
            tabIndex={1} // tabIndex of textarea
            onBlur={(content) => onContentChange(content, field)} // preferred to use only this option to update the content for performance reasons
            height={1000}
            allowResizeX={true}
            allowResizeY={true}
        />
    </>)
}